import { SvgIcon, SvgIconProps } from '@mui/material';

const Craftsman = ({ viewBox = '0 0 114 64', ...props }: SvgIconProps) => (
  <SvgIcon
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 114, height: 64, fill: 'none', ...props.sx }}
    data-testid="craftsmanIcon"
  >
    <path d="M109.733 60.1277H34.8867V63.5697H109.733V60.1277Z" fill="white" />
    <path d="M34.8688 43.0432H3.26318V60.1099H34.8688V43.0432Z" fill="white" />
    <path
      d="M34.869 33.0935H5.46848L0.592285 41.4655L0.610208 43.0431H34.887L34.869 33.0935Z"
      fill="white"
    />
    <path d="M34.8868 60.1099H3.28125V63.5698H34.8868V60.1099Z" fill="white" />
    <path d="M109.661 25.116H34.8511V59.8409H109.661V25.116Z" fill="white" />
    <path
      d="M25.7621 47.7581H12.9263V55.2516H25.7621V47.7581Z"
      fill="#B6D6F7"
    />
    <path
      d="M24.812 48.7082V54.3015H13.8764V48.7082H24.812ZM25.7621 47.7581H12.9263V55.2516H25.7621V47.7581Z"
      fill="#5196E5"
    />
    <path
      d="M51.7207 31.5518H41.9146V40.2106H51.7207V31.5518Z"
      fill="#B6D6F7"
    />
    <path
      d="M68.7153 31.5518H58.9092V40.2106H68.7153V31.5518Z"
      fill="#B6D6F7"
    />
    <path
      d="M85.7104 31.5518H75.9043V40.2106H85.7104V31.5518Z"
      fill="#80B6F0"
    />
    <path
      d="M102.706 31.5518H92.8994V40.2106H102.706V31.5518Z"
      fill="#80B6F0"
    />
    <path
      d="M68.7153 45.3557H58.9092V54.0145H68.7153V45.3557Z"
      fill="#B6D6F7"
    />
    <path
      d="M85.0293 45.8398H76.5498V60.1457H85.0293V45.8398Z"
      fill="#B6D6F7"
    />
    <path
      d="M84.043 46.8258V59.3928H77.41V46.8258H84.043ZM84.778 46.0908H76.6929V60.1457H84.778V46.0908Z"
      fill="#5196E5"
    />
    <path
      d="M34.8511 41.4834H0.592285L5.46848 33.0935H34.8511V41.4834Z"
      fill="#80B6F0"
    />
    <path
      d="M34.8511 41.4836H28.2539L32.1082 33.1116H34.8511V41.4836Z"
      fill="#5196E5"
    />
    <path
      d="M34.8868 43.0432H3.28125V44.7821H34.8868V43.0432Z"
      fill="#5196E5"
    />
    <path d="M34.851 43.1865H33.4526V63.5876H34.851V43.1865Z" fill="#5196E5" />
    <path
      d="M109.751 25.3491H34.8511V27.2135H109.751V25.3491Z"
      fill="#5196E5"
    />
    <path
      d="M34.8512 63.5878H16.7627L18.4658 60.1458H34.8512V63.5878Z"
      fill="#5196E5"
    />
    <path
      d="M113.641 23.9508L72.1035 0.448242L30.5483 23.9328V23.9508V25.5642H113.641V23.9508Z"
      fill="white"
    />
    <path
      d="M113.641 23.7535H30.5483L72.1214 0.250977L113.641 23.7535Z"
      fill="#B6D6F7"
    />
    <path
      d="M60.6844 54.0145L68.8592 45.9473H67.2457L59.2144 53.8711V54.0145H60.6844Z"
      fill="white"
    />
    <path
      d="M64.1261 54.0146L68.7155 49.4252V47.8118L62.5127 54.0146H64.1261Z"
      fill="white"
    />
    <path
      d="M77.4461 39.9058L85.6388 31.8386H84.0075L75.9761 39.7624V39.9058H77.4461Z"
      fill="white"
    />
    <path
      d="M80.8879 39.9059L85.4772 35.3166V33.7031L79.2744 39.9059H80.8879Z"
      fill="white"
    />
    <path
      d="M43.5457 39.9058L51.7384 31.8386H50.1071L42.0757 39.7624V39.9058H43.5457Z"
      fill="white"
    />
    <path
      d="M46.988 39.9059L51.5773 35.3166V33.7031L45.3745 39.9059H46.988Z"
      fill="white"
    />
    <path
      d="M60.6844 40.2286L68.8592 32.1614H67.2457L59.2144 40.0852V40.2286H60.6844Z"
      fill="white"
    />
    <path
      d="M64.1261 40.2287L68.7155 35.6393V34.0259L62.5127 40.2287H64.1261Z"
      fill="white"
    />
    <path
      d="M93.993 40.2286L102.186 32.1614H100.572L92.5229 40.0852V40.2286H93.993Z"
      fill="white"
    />
    <path
      d="M97.4527 40.2287L102.024 35.6393V34.0259L95.8213 40.2287H97.4527Z"
      fill="white"
    />
    <path
      d="M67.7652 46.3059V53.0644H59.8593V46.3059H67.7652ZM68.7153 45.3557H58.9092V54.0145H68.7153V45.3557Z"
      fill="#5196E5"
    />
    <path
      d="M102.795 45.3557H92.9888V54.0145H102.795V45.3557Z"
      fill="#B6D6F7"
    />
    <path
      d="M94.7459 54.0145L102.939 45.9473H101.325L93.2759 53.8711V54.0145H94.7459Z"
      fill="white"
    />
    <path
      d="M98.2056 54.0146L102.777 49.4252V47.8118L96.5742 54.0146H98.2056Z"
      fill="white"
    />
    <path
      d="M101.827 46.3059V53.0644H93.9213V46.3059H101.827ZM102.777 45.3557H92.9712V54.0145H102.777V45.3557Z"
      fill="#5196E5"
    />
    <path
      d="M51.7207 45.3557H41.9146V54.0145H51.7207V45.3557Z"
      fill="#B6D6F7"
    />
    <path
      d="M43.6891 54.0145L51.8639 45.9473H50.2505L42.2012 53.8711V54.0145H43.6891Z"
      fill="white"
    />
    <path
      d="M47.131 54.0146L51.7204 49.4252V47.8118L45.5176 54.0146H47.131Z"
      fill="white"
    />
    <path
      d="M50.7706 46.3059V53.0644H42.8647V46.3059H50.7706ZM51.7207 45.3557H41.9146V54.0145H51.7207V45.3557Z"
      fill="#5196E5"
    />
    <path
      d="M67.7652 32.5019V39.2604H59.8593V32.5019H67.7652ZM68.7153 31.5518H58.9092V40.2106H68.7153V31.5518Z"
      fill="#5196E5"
    />
    <path
      d="M50.7706 32.5019V39.2604H42.8647V32.5019H50.7706ZM51.7207 31.5518H41.9146V40.2106H51.7207V31.5518Z"
      fill="#5196E5"
    />
    <path
      d="M84.7423 32.5019V39.2604H76.8364V32.5019H84.7423ZM85.6924 31.5518H75.8862V40.2106H85.6924V31.5518Z"
      fill="#5196E5"
    />
    <path
      d="M101.737 32.5019V39.2604H93.8315V32.5019H101.737ZM102.687 31.5518H92.8813V40.2106H102.687V31.5518Z"
      fill="#5196E5"
    />
    <path
      d="M54.8042 19.5046H49.7129V21.7276H54.8042V19.5046Z"
      fill="#80B6F0"
    />
    <path
      d="M59.8955 16.8875H54.8042V19.1104H59.8955V16.8875Z"
      fill="#80B6F0"
    />
    <path
      d="M85.3698 8.85596H79.8662V11.2582H85.3698V8.85596Z"
      fill="#80B6F0"
    />
    <path
      d="M109.518 48.6724H105.646V50.3575H109.518V48.6724Z"
      fill="#D3E6FA"
    />
    <path
      d="M40.6775 56.0583H36.8052V57.7435H40.6775V56.0583Z"
      fill="#D3E6FA"
    />
    <path d="M7.4045 51.8811H3.53223V53.5663H7.4045V51.8811Z" fill="#D3E6FA" />
    <path
      d="M8.96446 49.4072H7.02832V51.0924H8.96446V49.4072Z"
      fill="#D3E6FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.93 25.7613H113.838V23.6459L72.1755 0.0896358L72.0142 0L30.3694 23.5384L30.208 23.6459V25.7613H34.4568V32.8964H5.16379L0.162109 41.5014L0.180043 43.4734H2.85118V59.9126V60.54V64H35.0842L35.0842 63.6952V60.558H48.4041H63.6601L64.9688 60.558L74.5957 60.558V64H86.822V60.558H109.303V63.6952H109.93V25.7613ZM113.211 25.1339H30.8355V24.0045L72.0142 0.717087L113.211 24.0045V25.1339ZM35.0842 59.9126L35.0842 59.9305L48.4041 59.9305H63.6601L64.9688 59.9305L74.5957 59.9305V43.9216H86.822V59.9305H109.303V25.7614H35.0842V38.1837L35.1021 43.4734H35.0842V59.9126ZM75.2411 60.558V63.3725H86.2125V60.558H75.2411ZM5.54026 33.5238H34.4568V42.8459H2.85118H0.807494V41.6627L5.54026 33.5238ZM3.47864 43.4734H34.4568V59.9126H3.47864V43.4734ZM3.47864 60.5401L34.4568 60.54V60.558V63.3726H3.47864V60.5401ZM25.9952 55.6639H12.5319V47.5429H25.9952V55.6639ZM13.1593 55.0364H16.8702V52.0067H13.1593V55.0364ZM13.1593 51.3793H16.8702V48.1703H13.1593V51.3793ZM17.4977 48.1703V51.3793H20.8859V48.1703H17.4977ZM20.8859 52.0067H17.4977V55.0364H20.8859V52.0067ZM21.5134 55.0364V52.0067H25.3677V55.0364H21.5134ZM25.3677 48.1703V51.3793H21.5134V48.1703H25.3677ZM85.2803 45.6246V59.9305H86.2125V44.549H75.2411V59.9305H76.1733V45.6246H85.2803ZM84.6349 52.7776V46.2521H76.7828V52.7776H84.6349ZM84.6349 59.9305V53.405H76.7828V59.9305H84.6349ZM51.9537 31.1395V40.8022H41.5201V31.1395H51.9537ZM42.1655 40.1748H51.3442V31.767H42.1655V40.1748ZM58.515 31.1395V40.8022H68.9486V31.1395H58.515ZM68.3212 31.767V40.1748H59.1425V31.767H68.3212ZM85.9257 31.1395V40.8022H75.4921V31.1395H85.9257ZM76.1374 40.1748H85.3162V31.767H76.1374V40.1748ZM92.487 31.1395V40.8022H102.921V31.1395H92.487ZM102.311 31.767V40.1748H93.1324V31.767H102.311ZM68.9486 54.6241H58.515V44.9613H68.9486V54.6241ZM59.1425 53.9966H68.3212V45.5888H59.1425V53.9966ZM92.5767 44.9613V54.6241H103.01V44.9613H92.5767ZM102.401 45.5888V53.9966H93.222V45.5888H102.401ZM51.9537 54.6241H41.5201V44.9613H51.9537V54.6241ZM42.1475 53.9966H51.3262V45.5888H42.1475V53.9966Z"
      fill="#4D5160"
    />
  </SvgIcon>
);

export default Craftsman;
